import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import api from "../../../api/api";
import { CONFIRM_LAST_FOUR, QUERY_ACCOUNT } from "../../../api/queryKeys";
import { DebitCardStatusEnum } from "../../../types";

export default function useSetCardPin() {
  const queryClient = useQueryClient();
  return useMutation<
    any,
    AxiosError,
    { cardId: number; last4: string; pin: string }
  >(
    ({ cardId, last4, pin }) =>
      api.patch(`${CONFIRM_LAST_FOUR}${cardId}/`, {
        last4,
        pin,
        tp_status: DebitCardStatusEnum.active,
      }),
    {
      onSuccess: () => {
        queryClient.refetchQueries([QUERY_ACCOUNT]);
      },
    }
  );
}
